import jQuery from 'jquery';

/**
 *
 */
function filterInformation() {
  return new Promise((resolve, reject) => {
    let bankArray = [];
    const countryObj = {};
    const cardArray = [];

    jQuery.ajax('/garminpay/banks/api/banks').then((data) => {
      const selectedCountry = jQuery('#js__select-country').find(':selected').val();
      if (selectedCountry === 'all') {
      // all countries selected
        const selectedCard = jQuery('#js__select-card-type').find(':selected').val();
        if (selectedCard === 'all') {
        // all cards selected
          Object.keys(data).forEach((country) => {
            countryObj[country] = data[country].name;
            Object.keys(data[country].banks).forEach((bank) => {
              if (cardArray.indexOf(bank) === -1) {
                cardArray.push(bank);
              }
              data[country].banks[bank].issuers.forEach((issue, index) => {
                bankArray.push(`${data[country].banks[bank].issuers[index]}: ${bank}`);
              });
            });
          });
        } else {
        // specific card selected
          Object.keys(data).forEach((country) => {
            countryObj[country] = data[country].name;
            Object.keys(data[country].banks).forEach((bank) => {
              if (cardArray.indexOf(bank) === -1) {
                cardArray.push(bank);
              }
            });
            if (data[country].banks[selectedCard]) {
              bankArray = bankArray.concat(data[country].banks[selectedCard].issuers);
            }
          });
        }
      } else {
      // specific country selected
        const selectedCard = jQuery('#js__select-card-type').find(':selected').val();
        if (selectedCard === 'all') {
        // all cards selected
          countryObj[selectedCountry] = data[selectedCountry].name;
          Object.keys(data[selectedCountry].banks).forEach((bank) => {
            if (cardArray.indexOf(bank) === -1) {
              cardArray.push(bank);
            }
            data[selectedCountry].banks[bank].issuers.forEach((issue, index) => {
              bankArray.push(`${data[selectedCountry].banks[bank].issuers[index]}: ${bank}`);
            });
          });
        } else {
        // specific card selected
          bankArray = bankArray.concat(data[selectedCountry].banks[selectedCard].issuers);
        }
      }
      // sort countryObj alphabetically by country
      const sortable = Object.entries(countryObj).sort(([, a], [, b]) => a.localeCompare(b));
      const sortableCountryObj = sortable.reduce((result, item) => {
        const key = item[0]; // first property: AR, AU.. (countryCode)
        // eslint-disable-next-line no-param-reassign,prefer-destructuring
        result[key] = item[1]; // second property: Argentina, Australia... (country)
        return result;
      }, {});
      // sort all the arrays
      bankArray.sort();
      cardArray.sort();
      resolve({ country: sortableCountryObj, bank: bankArray, card: cardArray });
    }).catch((error) => {
      reject(error);
    });
  });
}

/**
 *
 * @param {Array} banks banks to be filtered
 */
function checkMaxBank(banks) {
  if (banks.find((bankName) => bankName.toLowerCase().indexOf('max') !== -1)) {
    jQuery('.gp_max_details').removeClass('gp__visuallyhidden');
  } else {
    jQuery('.gp_max_details').addClass('gp__visuallyhidden');
  }
}

jQuery(document).ready(() => {
  // card dropdown event handler
  jQuery('#js__select-card-type').change(() => {
    filterInformation().then((filter) => {
      jQuery('#js__bank-list').empty();

      for (let i = 0; i < filter.bank.length; i += 1) {
        if (filter.bank[i + 1] && filter.bank[i] === filter.bank[i + 1]) {
          filter.bank.splice(i, 1);
          i -= 1;
        }
      }
      for (let i = 0; i < filter.bank.length; i += 1) {
        jQuery('#js__bank-list').append(`<li>${filter.bank[i]}</li>`);
      }

      // If we have Max as an option we display some additional info at the bottom
      checkMaxBank(filter.bank);
    });
  });

  // country dropdown event handler
  jQuery('#js__select-country').change(() => {
    const cardTypeSelect = jQuery('#js__select-card-type');
    const selectAllTranslation = cardTypeSelect.find('option:first').text();
    const allOption = new Option(selectAllTranslation, 'all', true, true);

    cardTypeSelect.empty();
    cardTypeSelect.append(allOption);

    filterInformation().then((filter) => {
      for (let i = 0; i < filter.card.length; i += 1) {
        cardTypeSelect.append(new Option(filter.card[i], filter.card[i], false, false));
      }
      // If we have Max as an option we display some additional info at the bottom
      checkMaxBank(filter.bank);
      cardTypeSelect.change();
    });
  });

  // initial load handler
  const countrySelect = jQuery('#js__select-country');
  const selectAllTranslation = countrySelect.find('option:first').text();
  const allOption = new Option(selectAllTranslation, 'all', true, true);

  countrySelect.empty();
  countrySelect.append(allOption);

  filterInformation().then((filter) => {
    Object.keys(filter.country).forEach((country) => {
      countrySelect.append(new Option(filter.country[country], country, false, false));
    });
    countrySelect.change();
  });
});
// });
